(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
class AnnouncementBar {
  constructor() {
    this.state = {
      $announcementSlides: document.querySelectorAll('.js-announcement-slide'),
      $pauseButton: document.querySelector('.js-announcement-pause'),
      timer: null,
      isPaused: false,
      currentSlideIndex: 0
    };
    
    if (this.state.$announcementSlides.length < 2) {
      if (this.state.$pauseButton) {
        this.state.$pauseButton.hidden = true;
      }
      return;
    }

    if (this.state.$pauseButton) {
      this.state.$pauseButton.hidden = false;
    }

    this.updateSlideVisibility();
    this.bindPauseButton();
    this.runAnnouncementSlideshow();
  }

  bindPauseButton() {
    if (!this.state.$pauseButton) {
      return;
    }

    this.state.$pauseButton.addEventListener('click', () => {
      this.state.isPaused = !this.state.isPaused;
      this.state.$pauseButton.setAttribute('aria-pressed', this.state.isPaused ? 'true' : 'false');
      this.state.$pauseButton.setAttribute('aria-label', this.state.isPaused ? 'Resume announcements' : 'Pause announcements');

      if (this.state.isPaused) {
        window.clearTimeout(this.state.timer);
        this.state.timer = null;
      } else {
        this.runAnnouncementSlideshow();
      }
    });
  }

  updateSlideVisibility() {
    const slides = this.state.$announcementSlides;

    slides.forEach((slide) => {
      if (slide.classList.contains('active')) {
        slide.removeAttribute('aria-hidden');
        slide.removeAttribute('inert');
      } else {
        slide.setAttribute('aria-hidden', 'true');
        slide.setAttribute('inert', '');
      }
    });
  }

  runAnnouncementSlideshow() {
    const slides = this.state.$announcementSlides;
    
    if (slides.length > 1 && !this.state.isPaused) {
      window.clearTimeout(this.state.timer);
      let currentIndex = -1;
      let nextIndex = 0;
      
      // Find the current active slide
      for (let i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('active')) {
          currentIndex = i;
          nextIndex = (i + 1) % slides.length;
          break;
        }
      }
      
      // Set the current slide index
      this.state.currentSlideIndex = nextIndex;
      
      // Switch to next slide after 5 seconds
      this.state.timer = window.setTimeout(() => {
        if (this.state.isPaused) {
          return;
        }

        const announcementBar = slides[nextIndex].closest('.header--announcement-bar');

        if (announcementBar && announcementBar.hasAttribute('data-theme-editor-locked-slide')) {
          this.runAnnouncementSlideshow();
          return;
        }

        if (slides[nextIndex]) {
          // Start both transitions simultaneously
          slides[nextIndex].classList.add('active');
          if (currentIndex >= 0) {
            slides[currentIndex].classList.remove('active');
          }
          this.updateSlideVisibility();
          
          // Continue slideshow
          this.runAnnouncementSlideshow();
        }
      }, 5000);
    }
  }
}

// Initialize announcement bar when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new AnnouncementBar();
  });
} else {
  new AnnouncementBar();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const cookieLinks = document.querySelectorAll('a[href="#cookie-settings"], a[href="#cookie-settings-link"]');

    cookieLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();

        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
          window.privacyBanner.showPreferences().catch((error) => {
            console.error('Failed to open cookie preferences:', error);
          });
        } else if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.showPreferencesPopup === 'function') {
          window.Shopify.customerPrivacy.showPreferencesPopup();
        } else {
          console.warn('Cookie consent system not available. Ensure privacy settings are configured in Shopify admin.');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var activeClass = 'header-dropdown-active';
    var triggerSelector = '.header--link-wrapper, .header--icon-wrapper';
    var activeSurfaceSelector = '.header--link-wrapper:hover .header--submenu, .header--link-wrapper.active .header--submenu, .header--icon-wrapper:hover .header--search-form, .header--icon-wrapper.active .header--search-form';

    function setHeaderDropdownActive(isActive) {
      if (!document.body || !document.body.classList) return;
      document.body.classList.toggle(activeClass, isActive);
    }

    function hasActiveHeaderSurface() {
      return !!document.querySelector(activeSurfaceSelector);
    }

    function refreshHeaderDropdownActive() {
      setHeaderDropdownActive(hasActiveHeaderSurface());
    }

    function bindHeaderDropdownFallback() {
      var triggers = document.querySelectorAll(triggerSelector);

      for (var i = 0; i < triggers.length; i += 1) {
        triggers[i].addEventListener('mouseenter', function () {
          setHeaderDropdownActive(true);
        });
        triggers[i].addEventListener('focusin', function () {
          setHeaderDropdownActive(true);
        });
        triggers[i].addEventListener('mouseleave', function () {
          window.setTimeout(refreshHeaderDropdownActive, 0);
        });
        triggers[i].addEventListener('focusout', function () {
          window.setTimeout(refreshHeaderDropdownActive, 0);
        });
        triggers[i].addEventListener('click', function () {
          window.setTimeout(refreshHeaderDropdownActive, 0);
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindHeaderDropdownFallback);
    } else {
      bindHeaderDropdownFallback();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["list-collections-template"]) return;
  try {
    
  // Initialize custom scrollbars when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  const containers = document.querySelectorAll('.list-collections-template--nav-container');
  containers.forEach(container => new CustomScrollbar(container));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-steps"] && !Shopify.designMode) return;
  try {
    
  class ProductSteps {
    constructor(container) {
      this.container = container;
      this.buttons = container.querySelectorAll('.product-steps_button');
      this.columns = container.querySelectorAll('.product-steps_column');
      this.captions = container.querySelectorAll('.product-steps_caption');
      this.images = container.querySelectorAll('.product-steps_image');
      this.imagesLoaded = false;
      this.init();
    }

    init() {
      this.buttons.forEach(button => {
        button.addEventListener('click', () => this.handleStepChange(button));
      });

      // Setup intersection observer for lazy loading
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.imagesLoaded) {
            this.preloadAllImages();
            this.imagesLoaded = true;
            observer.unobserve(entry.target);
          }
        });
      }, {
        rootMargin: '100px 0px'
      });

      observer.observe(this.container);
    }

    preloadAllImages() {
      this.images.forEach(img => {
        if (img.dataset.src) {
          const newImg = new Image();
          newImg.src = img.dataset.src;
          newImg.onload = () => {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          };
        }
      });
    }

    handleStepChange(clickedButton) {
      const stepIndex = clickedButton.dataset.step;
      
      // Update buttons
      this.buttons.forEach(button => {
        button.classList.toggle('is-active', button === clickedButton);
      });
      
      // Update columns with fade
      this.columns.forEach(column => {
        if (column.dataset.step === stepIndex) {
          if (!column.classList.contains('is-active')) {
            column.style.display = 'flex';
            // Trigger reflow
            column.offsetHeight;
            column.classList.add('is-active');
          }
        } else {
          column.classList.remove('is-active');
          // Wait for fade out before hiding
          setTimeout(() => {
            if (!column.classList.contains('is-active')) {
              column.style.display = 'none';
            }
          }, 300);
        }
      });

      // Update captions
      this.captions.forEach(caption => {
        caption.classList.toggle('is-active', caption.dataset.step === stepIndex);
      });
    }
  }

  // Initialize the product steps
  window.addEventListener('DOMContentLoaded', () => {
    const productStepsContainers = document.querySelectorAll('.product-steps');
    productStepsContainers.forEach(container => {
      new ProductSteps(container);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sustainability-2col"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setActiveTab(root, tabName) {
      root.querySelectorAll('[data-sustainability-tab-button]').forEach(function (button) {
        var isActive = button.getAttribute('data-sustainability-tab-button') === tabName;
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      root.querySelectorAll('[data-sustainability-tab-panel]').forEach(function (panel) {
        var isActive = panel.getAttribute('data-sustainability-tab-panel') === tabName;
        panel.hidden = !isActive;
      });
    }

    function initSustainabilityTabs(scope) {
      (scope || document).querySelectorAll('[data-sustainability-tabs]').forEach(function (root) {
        if (root.dataset.sustainabilityTabsInitialized === 'true') return;
        root.dataset.sustainabilityTabsInitialized = 'true';

        root.addEventListener('click', function (event) {
          var button = event.target.closest('[data-sustainability-tab-button]');
          if (!button || !root.contains(button)) return;
          setActiveTab(root, button.getAttribute('data-sustainability-tab-button'));
        });

        root.addEventListener('keydown', function (event) {
          var button = event.target.closest('[data-sustainability-tab-button]');
          if (!button || !root.contains(button)) return;

          var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-sustainability-tab-button]'));
          var currentIndex = buttons.indexOf(button);
          var nextIndex = currentIndex;

          if (event.key === 'ArrowRight') {
            nextIndex = (currentIndex + 1) % buttons.length;
          } else if (event.key === 'ArrowLeft') {
            nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = buttons.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          buttons[nextIndex].focus();
          setActiveTab(root, buttons[nextIndex].getAttribute('data-sustainability-tab-button'));
        });
      });
    }

    initSustainabilityTabs(document);

    document.addEventListener('shopify:section:load', function (event) {
      initSustainabilityTabs(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabsContainers = document.querySelectorAll('.tabs');

    // Collect all tab IDs from all tab containers
    const allTabIds = [];
    const tabIdToElementMap = new Map();

    tabsContainers.forEach(function(container) {
      const tabs = container.querySelectorAll('.tab_title[data-tab-id]');
      tabs.forEach(function(tab) {
        const tabId = tab.getAttribute('data-tab-id');
        if (tabId && tabId.trim() !== '') {
          allTabIds.push(tabId);
          tabIdToElementMap.set(tabId, tab);
        }
      });
    });

    // Function to handle tab activation
    function activateTabById(tabId) {
      const targetTab = tabIdToElementMap.get(tabId);
      if (targetTab) {
        // Click the tab to activate it
        targetTab.click();

        // Scroll to the top of the tabs container
        setTimeout(() => {
          const tabContainer = targetTab.closest('.tabs');
          if (tabContainer) {
            tabContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);

        return true;
      }
      return false;
    }

    // Find all links that point to tab IDs and add listeners
    const allLinks = document.querySelectorAll('a[href^="#"]');
    allLinks.forEach(function(link) {
      const href = link.getAttribute('href');
      const tabId = href.substring(1); // Remove the # symbol

      if (allTabIds.includes(tabId)) {
        link.addEventListener('click', function(e) {
          e.preventDefault(); // Prevent default link behavior
          activateTabById(tabId);
        });
      }
    });

    // Handle initial page load hash
    function handleInitialHash() {
      const hash = window.location.hash.substring(1);
      if (hash && allTabIds.includes(hash)) {
        activateTabById(hash);
      }
    }

    // Check for hash on initial page load
    handleInitialHash();

    // Listen for hash changes (for browser back/forward)
    window.addEventListener('hashchange', function() {
      const hash = window.location.hash.substring(1);
      if (hash && allTabIds.includes(hash)) {
        activateTabById(hash);
      }
    });

    tabsContainers.forEach(function (tabsContainer) {
      const tabTitles = tabsContainer.querySelectorAll('.tab_title');
      const tabContents = tabsContainer.querySelectorAll('.tab_content');
      
      // Store Swiper instances for proper cleanup
      const swiperInstances = new Map();

      // Initialize accessibility attributes
      tabTitles.forEach(function (tabTitle, index) {
        const tabContent = tabContents[index];
        const customTabId = tabTitle.getAttribute('data-tab-id');
        const tabId = customTabId ? customTabId : 'tab-' + tabsContainer.closest('[id*="shopify-section"]').id + '-' + index;
        const panelId = 'panel-' + tabsContainer.closest('[id*="shopify-section"]').id + '-' + index;

        // Set up ARIA attributes
        tabTitle.setAttribute('role', 'tab');
        tabTitle.setAttribute('id', tabId);
        tabTitle.setAttribute('aria-controls', panelId);
        tabTitle.setAttribute('aria-selected', 'false');
        tabTitle.setAttribute('tabindex', '0'); // All tabs should be tabbable
        tabTitle.style.cursor = 'pointer';

        tabContent.setAttribute('role', 'tabpanel');
        tabContent.setAttribute('id', panelId);
        tabContent.setAttribute('aria-labelledby', tabId);
        tabContent.setAttribute('tabindex', '0');
        tabContent.setAttribute('aria-hidden', 'true'); // Hidden by default
        tabContent.style.display = 'none';
      });

      // Set up tab list role
      const tabsList = tabsContainer.querySelector('.tabs_list');
      tabsList.setAttribute('role', 'tablist');

      // Add click event listeners
      tabTitles.forEach(function (tabTitle, index) {
        tabTitle.addEventListener('click', function () {
          // Check if this tab is already active
          if (tabTitle.classList.contains('active')) {
            // Deactivate all tabs if clicking on active tab
            deactivateAllTabs();
          } else {
            // Activate the clicked tab
            activateTab(tabTitle, tabContents[index], false);
          }
        });

        // Add keyboard navigation
        tabTitle.addEventListener('keydown', function (e) {
          let targetIndex = index;

          switch (e.key) {
            case 'ArrowRight':
            case 'ArrowDown':
              e.preventDefault();
              targetIndex = (index + 1) % tabTitles.length;
              break;
            case 'ArrowLeft':
            case 'ArrowUp':
              e.preventDefault();
              targetIndex = (index - 1 + tabTitles.length) % tabTitles.length;
              break;
            case 'Home':
              e.preventDefault();
              targetIndex = 0;
              break;
            case 'End':
              e.preventDefault();
              targetIndex = tabTitles.length - 1;
              break;
            case 'Enter':
            case ' ':
              e.preventDefault();
              activateTab(tabTitle, tabContents[index], true);
              return;
            default:
              return;
          }

          // Focus and activate the target tab
          tabTitles[targetIndex].focus();
          activateTab(tabTitles[targetIndex], tabContents[targetIndex], true);
        });
      });

      function deactivateAllTabs() {
        // Destroy all Swiper instances
        swiperInstances.forEach(function(swiper, key) {
          if (swiper && typeof swiper.destroy === 'function') {
            swiper.destroy(true, true);
          }
        });
        swiperInstances.clear();

        // Remove active class and reset ARIA attributes from all tabs
        tabTitles.forEach(function (title) {
          title.classList.remove('active');
          title.setAttribute('aria-selected', 'false');
          // Keep tabindex="0" so tabs remain tabbable
        });

        // Hide all tab contents
        tabContents.forEach(function (content) {
          content.classList.remove('active');
          content.setAttribute('aria-hidden', 'true');
          content.style.display = 'none';
        });
      }

      function activateTab(activeTitle, activeContent, shouldFocus, shouldScroll = true) {
        // Destroy all existing Swiper instances before activating new tab
        swiperInstances.forEach(function(swiper, key) {
          if (swiper && typeof swiper.destroy === 'function') {
            swiper.destroy(true, true);
          }
        });
        swiperInstances.clear();

        // Remove active class and reset ARIA attributes from all tabs
        tabTitles.forEach(function (title) {
          title.classList.remove('active');
          title.setAttribute('aria-selected', 'false');
          // Keep tabindex="0" so all tabs remain tabbable
        });

        tabContents.forEach(function (content) {
          content.classList.remove('active');
          content.setAttribute('aria-hidden', 'true');
          content.style.display = 'none';
        });

        // Add active class and set ARIA attributes for clicked tab
        activeTitle.classList.add('active');
        activeTitle.setAttribute('aria-selected', 'true');
        // tabindex remains "0" for active tab

        activeContent.classList.add('active');
        activeContent.setAttribute('aria-hidden', 'false');
        activeContent.style.display = 'block';

        // Initialize swiper for this tab if necessary
        initOrDestroySwiperForTab(activeContent);

        // Scroll tab titles area to 100px from top (only if shouldScroll is true)
        if (shouldScroll) {
          const tabsList = activeTitle.closest('.tabs_list');
          if (tabsList) {
            const tabsListRect = tabsList.getBoundingClientRect();
            const scrollTarget = window.scrollY + tabsListRect.top - 100;
            window.scrollTo({
              top: scrollTarget,
              behavior: 'smooth'
            });
          }
        }

        // Only focus for keyboard navigation
        if (shouldFocus) {
          activeTitle.focus();
        }
      }

      /* -------- Swiper logic for overflowing tab blocks -------- */

      const DEBOUNCE_DELAY = 250;

      function debounce(fn, delay) {
        let timeoutId;
        return function () {
          const context = this;
          const args = arguments;
          clearTimeout(timeoutId);
          timeoutId = setTimeout(function () {
            fn.apply(context, args);
          }, delay);
        };
      }

      function initOrDestroySwiperForTab(tabContent) {
        if (!tabContent) return;
        const swiperContainer = tabContent.querySelector('.tab_blocks_swiper');
        if (!swiperContainer) return;

        const wrapper = swiperContainer.querySelector('.tab_blocks');
        if (!wrapper) return;

        // Create unique key for this swiper instance
        const swiperKey = tabContent.getAttribute('id') || tabContent.closest('.shopify-block')?.getAttribute('data-block-id') || Math.random().toString(36);

        // Destroy existing instance if it exists
        if (swiperInstances.has(swiperKey)) {
          const existingSwiper = swiperInstances.get(swiperKey);
          if (existingSwiper && typeof existingSwiper.destroy === 'function') {
            existingSwiper.destroy(true, true);
          }
          swiperInstances.delete(swiperKey);
        }

        // Clean up existing slide classes
        Array.from(wrapper.children).forEach(child => child.classList.remove('swiper-slide'));
        
        // Add slide class to direct children
        Array.from(wrapper.children).forEach(child => child.classList.add('swiper-slide'));

        const scrollbarEl = swiperContainer.querySelector('.tab_blocks_scrollbar');

        /* ----- Initialize new Swiper instance ----- */
        const swiperInstance = new Swiper(swiperContainer, {
          slidesPerView: 'auto',
          spaceBetween: 0,
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          speed: 350,
          scrollbar: {
            el: scrollbarEl,
            draggable: true,
            hide: false   // keep track & thumb always mounted
          },
          mousewheel: {
            releaseOnEdges: false,
            forceToAxis: true,
            sensitivity: 1,
          },
          breakpoints: {
            750: {
              freeMode: true,
              speed: 500,
              mousewheel: {
                releaseOnEdges: false,
                forceToAxis: true,
                sensitivity: 0.5
              }
            }
          }
        });

        // Store the instance for later cleanup
        swiperInstances.set(swiperKey, swiperInstance);

        /* Update once everything (images/fonts) has loaded */
        const updateHandler = () => swiperInstance.update();
        window.addEventListener('load', updateHandler, { once: true });

        // Remove scrollbar if not needed
        const swiperWidth  = swiperContainer.offsetWidth;
        const wrapperWidth = wrapper.offsetWidth;
        if (scrollbarEl && wrapperWidth - swiperWidth <= 30) {
          scrollbarEl.remove();
        } else if (scrollbarEl && !swiperContainer.contains(scrollbarEl)) {
          swiperContainer.appendChild(scrollbarEl);
        }
      }

      // On initial load, evaluate the active tab (if any) or activate first tab
      const initialActiveContent = tabsContainer.querySelector('.tab_content.active');
      if (initialActiveContent) {
        initOrDestroySwiperForTab(initialActiveContent);
      }
      // else if (tabTitles.length > 0 && tabContents.length > 0) {
      //   // No active tab found, activate the first tab by default
      //   activateTab(tabTitles[0], tabContents[0], false, false);
      // }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
